export const accountSetup = {
  payments: {
    planUnavailableTitle: "Non disponible avec votre forfait",
    planUnavailableMessage:
      "Les paiements des clients via Stripe sont disponibles uniquement à partir des forfaits Standard. Améliorez votre forfait pour activer cette fonctionnalité et commencer à encaisser les paiements directement, sans intermédiaires.",
  },
  modalConnection: {
    header: "Connecter un PMS",
    loaderMessage: "Enregistrement, veuillez patienter.",
    selectPmsLabel: "Sélectionnez un système PMS",
    selectPmsPlaceholder: "Sélectionnez un PMS",
    apiKeyLabel: "Clé API {pms}",
    apiKeyPlaceholder: "Saisissez votre clé API",
    cancel: "Annuler",
    save: "Enregistrer la connexion",
    fieldRequired: "Champ obligatoire",
    selectPmsError: "Sélectionnez un PMS",
    apiKeyError: "Veuillez saisir la clé API",
    savedTitle: "Connexion enregistrée",
    savedMessage: "La connexion a été enregistrée avec succès",
    saveFailMessage: "La connexion n'a pas pu être enregistrée",
    errorTitle: "Erreur",
    serverError: "Erreur de connexion au serveur",
  },
  subscription: {
    title: "Mon abonnement",
    subtitle: "Consultez et gérez votre forfait, votre mode de paiement et votre facturation.",
    statusActive: "Actif",
    // Cancelada pero todavía dentro de lo que ya pagó: ni «Activa» ni «Cancelada» a secas.
    statusCanceledValid: "Annulée · active jusqu'au",
    validUntil: "Active jusqu'au :",
    statusPaymentPending: "Paiement en attente",
    statusTrial: "Période d'essai",
    statusNone: "Aucun abonnement actif",
    intervalYearly: "Forfait annuel",
    intervalMonthly: "Forfait mensuel",
    perMonthShort: "/mois",
    nextRenewal: "Prochain renouvellement :",
    servicesIncluded: "Services inclus",
    units: "unité | unités",
    perUnitSuffix: "/unité",
    serviceFallback: "Service",
    manageOpening: "Ouverture…",
    manageButton: "Gérer l'abonnement et les factures",
    emptyText:
      "Vous n'avez pas encore de forfait actif. Choisissez-en un pour commencer à recevoir des check-ins et des paiements.",
    buyPlan: "Acheter un forfait",
    types: {
      apartment: "Appartement",
      hotel: "Hôtel",
      room: "Chambre",
      camping: "Camping",
      villa: "Villa",
      chatbot: "Réception IA",
    },
  },
  purchased: {
    title: "Disponible dans votre abonnement",
    subtitle: "Quota souscrit et utilisation actuelle",
    accommodations: "Hébergements",
    empty: "Vous n'avez encore créé aucun hébergement.",
    createProperty: "Créer un hébergement",
    adjust: "Ajuster",
    loadError: "Les informations n'ont pas pu être chargées.",
    labels: {
      apartment: "Appartement(s)",
      hotel: "Hôtel (Chambres)",
      hotelPack: "Hôtel (Chambres) · #{id}",
      villa: "Villas",
      camping: "Campings",
      campingPack: "Campings · #{id}",
      chatbot: "Licences chatbot",
    },
    units: {
      unid: "unités",
      room: "chambres",
      spots: "emplacements",
      licenses: "licences",
    },
    types: {
      hotel: "Hôtel",
      camping: "Camping",
      villa: "Villa",
      apartment: "Appartement",
    },
    badge: {
      rooms: "{n} chambres",
      spots: "{n} emplacements",
      unit: "1 unité",
    },
  },
  notifications: {
    title: "Notifications",
    description: "Activez ou désactivez les automatisations de messagerie et les alertes.",
    loading: "Chargement des paramètres...",
    alwaysActive: "Toujours actif",
    active: "Activé",
    inactive: "Désactivé",
    hint:
      "Remarque : certaines automatisations sont affichées à titre informatif car elles font déjà partie du flux standard du système.",
    loadError: "Les paramètres n'ont pas pu être chargés.",
    saveError: "La modification n'a pas pu être enregistrée. Nouvelle tentative...",
    items: {
      whatsapp_booking_confirmation: {
        title: "Confirmation de réservation (WhatsApp)",
        description:
          "Envoie automatiquement le modèle de confirmation lorsqu'une réservation est confirmée.",
      },
      email_checkin_sent: {
        title: "Notifications par e-mail lors de l'envoi du check-in",
        description:
          "Envoie un e-mail automatique lorsque le processus de check-in est terminé ou envoyé.",
      },
      whatsapp_checkin_link_auto: {
        title: "Envoyer un WhatsApp automatique pour le check-in en ligne",
        description:
          "Envoie automatiquement le lien de check-in en ligne via WhatsApp le cas échéant.",
      },
      checkin_link_send_policy: {
        title: "Politique d'envoi du lien de check-in pour les réservations directes",
        description:
          "Définissez si le lien est toujours envoyé ou uniquement lorsque la réservation est payée ou partiellement payée.",
        options: {
          always: {
            label: "Toujours envoyer",
            description:
              "Envoie le lien de check-in quel que soit le statut de paiement.",
          },
          paid_or_partially_paid: {
            label: "Uniquement payée ou partiellement payée",
            description:
              "Envoie le lien uniquement si la réservation est entièrement ou partiellement payée. S'applique uniquement aux réservations directes.",
          },
        },
      },
    },
  },
  wompi: {
    country: "Colombie",
    statusVerified: "Connecté",
    statusPending: "Non vérifié",
    publicKeyLabel: "Clé publique",
    privateKeyLabel: "Clé privée",
    keepPrivateLabel: "Conserver la clé privée enregistrée (masquée pour des raisons de sécurité)",
    privatePlaceholderSaved: "•••••••••••• (enregistrée)",
    btnDisconnect: "Déconnecter",
    btnVerify: "Vérifier le compte",
    btnSave: "Enregistrer les identifiants",
    merchantHeader: "Marchand détecté",
    missingPublicKey: "Clé publique manquante",
    missingPrivateKey: "Clé privée manquante",
    savedOk: "Identifiants enregistrés avec succès",
    saveError: "Erreur lors de l'enregistrement des identifiants",
    verifiedOk: "Compte vérifié",
    notVerified: "Compte non vérifié",
    verifyError: "Erreur lors de la vérification du compte",
    disconnectConfirm: "Voulez-vous vraiment déconnecter Wompi de cette entreprise ?",
    disconnectedOk: "Déconnecté avec succès",
    disconnectError: "Erreur lors de la déconnexion",
  },
  pricelabs: {
    subtitle: "Optimisation dynamique des prix",
    statusConnected: "Connecté",
    statusDisconnected: "Non connecté",
    loading: "Chargement des paramètres...",
    emailLabel: "E-mail PriceLabs",
    emailPlaceholder: "your-email@pricelabs.com",
    importantTitle: "Important :",
    bullet1: "Assurez-vous que vos hébergements sont entièrement configurés",
    bullet2: "Choisissez les annonces à envoyer vers PriceLabs",
    bullet3:
      "Les prix seront mis à jour selon PriceLabs et ne pourront pas être modifiés manuellement depuis Wacheckin",
    btnConnect: "Connecter et synchroniser",
    btnConnecting: "Connexion...",
    btnSync: "Synchroniser",
    btnSyncing: "Synchronisation...",
    btnDisconnect: "Déconnecter",
    btnDisconnecting: "Déconnexion...",
    emailRequired: "Veuillez saisir votre e-mail PriceLabs",
    emailRequiredTitle: "E-mail requis",
    connectHeader: "Se connecter à PriceLabs ?",
    connectMessage:
      "Tous vos hébergements et chambres actifs seront liés. Les tarifs et la disponibilité seront synchronisés. Tout hébergement/chambre créé par la suite sera envoyé automatiquement.",
    connectAccept: "Oui, connecter",
    cancel: "Annuler",
    linkError: "Erreur lors de la liaison des unités",
    emailNotFoundConnect:
      "PriceLabs a signalé que l'e-mail n'existe pas. Vérifiez votre e-mail et réessayez.",
    emailInvalidTitle: "E-mail PriceLabs invalide",
    syncSuccess: "Vos hébergements sont désormais connectés à PriceLabs.",
    syncSuccessTitle: "Synchronisation terminée !",
    syncFail: "La synchronisation n'a pas pu être effectuée",
    errorTitle: "Erreur",
    emailNotFoundManual:
      "PriceLabs a indiqué que l'e-mail n'existe pas. Corrigez l'e-mail et synchronisez à nouveau.",
    manualSuccess: "Le processus s'est terminé avec succès.",
    manualSuccessTitle: "Synchronisation manuelle",
    manualFail: "Impossible de synchroniser avec PriceLabs",
    rejected: "PriceLabs a refusé {count} annonce(s). {detail}",
    rejectedTitle: "Synchronisation impossible",
    nothingSent: "Aucune annonce envoyée. Vérifiez que celles choisies ont un prix et une devise.",
    relinked: "{count} annonce(s) étaient encore liées à un autre compte PriceLabs : elles ont été envoyées avec un nouvel identifiant, elles apparaissent donc comme nouvelles.",
    relinkedTitle: "Nouvel identifiant",
    syncedAt: "Synchronisé · {when}",
    notSyncedYet: "Connecté, pas encore envoyé",
    noneSelected: "Vous n'avez choisi aucun logement. Sélectionnez ceux à envoyer vers PriceLabs puis resynchronisez.",
    disconnectHeader: "Déconnecter PriceLabs ?",
    disconnectMessage: "Tous vos hébergements seront dissociés de PriceLabs.",
    disconnectAccept: "Oui, déconnecter",
    disconnectedOk: "Votre compte a été déconnecté de PriceLabs",
    disconnectedTitle: "Déconnecté",
    disconnectFail: "Impossible de se déconnecter de PriceLabs",
    noErrorsReported: "Aucune erreur signalée.",
    listingPrefix: "Annonce {id} : ",
    unknownError: "Erreur inconnue",
    listTitle: "Quelles annonces vont vers PriceLabs",
    listHint: "Choisissez celles que PriceLabs doit gérer. Celles que vous laissez désactivées gardent leurs tarifs et c'est vous qui les modifiez.",
    listCount: "{n} sur {total} sélectionnées",
    listSearch: "Rechercher un hébergement ou une chambre…",
    listRooms: "{n} chambres",
    listApartment: "Appartement",
    listEmpty: "Vous n'avez pas encore d'hébergements.",
    listNoMatch: "Aucun hébergement de ce nom.",
    listNeedsCurrency: "Devise manquante",
    listNeedsRate: "Tarif manquant",
    btnConnectN: "Connecter et synchroniser | Connecter et synchroniser {n} | Connecter et synchroniser {n}",
    unitConnected: "{name} va désormais vers PriceLabs",
    unitDisconnected: "{name} ne va plus vers PriceLabs",
    unitFail: "Impossible de modifier. Réessayez.",
    listLocked: "Connectez votre compte PriceLabs et vous pourrez choisir ici les annonces qu'il gère.",
    listAll: "Toutes",
    listNone: "Aucune",
    btnSyncN: "Synchroniser | Synchroniser 1 annonce | Synchroniser {n} annonces",
    connectedOk: "Compte connecté. Choisissez maintenant les annonces qui vont vers PriceLabs.",
    connectedTitle: "C'est fait",
  },
};